import { Box, Grid, Typography } from "@mui/material";
import DatepickerField from "components/DatepickerField";
import FormField from "components/FormField";
import SelectField from "components/SelectField";
import SwitchField from "components/SwitchField";
import { memo } from "react";

/* eslint-disable react/prop-types */

function Fields({ formData }) {
  const { formField, values, errors, touched } = formData;
  const {
    date,
    startDate,
    endDate,
    numberContract,
    firstTime,
    supplementaryForThe,
    taxAlternatePayerId,
    taxAlternatePayerName,
    taxAgencyName,
    taxId,
    taxAgentContract,
    taxAgentContractDate,
  } = formField;
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={numberContract.name}
            label={numberContract.label}
            value={values.numberContract}
            error={errors.numberContract && touched.numberContract}
            success={values.numberContract?.toString().length > 0 && !errors.numberContract}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <DatepickerField
            label={date.label}
            name={date.name}
            error={errors.date && touched.date}
            success={values.date?.toString().length > 0 && !errors.date}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <DatepickerField
            label={startDate.label}
            name={startDate.name}
            error={errors.startDate && touched.startDate}
            success={values.startDate?.toString().length > 0 && !errors.startDate}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <DatepickerField
            label={endDate.label}
            name={endDate.name}
            error={errors.endDate && touched.endDate}
            success={values.endDate?.toString().length > 0 && !errors.endDate}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <SwitchField name={firstTime.name} label={firstTime.label} value={values.firstTime} />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={supplementaryForThe.name}
            label={supplementaryForThe.label}
            value={values.supplementaryForThe}
            error={errors.supplementaryForThe && touched.supplementaryForThe}
            success={
              values.supplementaryForThe?.toString().length > 0 && !errors.supplementaryForThe
            }
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAlternatePayerName.name}
            label={taxAlternatePayerName.label}
            value={values.taxAlternatePayerName}
            error={errors.taxAlternatePayerName && touched.taxAlternatePayerName}
            success={
              values.taxAlternatePayerName?.toString().length > 0 && !errors.taxAlternatePayerName
            }
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAlternatePayerId.name}
            label={taxAlternatePayerId.label}
            value={values.taxAlternatePayerId}
            error={errors.taxAlternatePayerId && touched.taxAlternatePayerId}
            success={
              values.taxAlternatePayerId?.toString().length > 0 && !errors.taxAlternatePayerId
            }
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgencyName.name}
            label={taxAgencyName.label}
            value={values.taxAgencyName}
            error={errors.taxAgencyName && touched.taxAgencyName}
            success={values.taxAgencyName?.toString().length > 0 && !errors.taxAgencyName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxId.name}
            label={taxId.label}
            value={values.taxId}
            error={errors.taxId && touched.taxId}
            success={values.taxId?.toString().length > 0 && !errors.taxId}
          />
        </Grid>

        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgentContract.name}
            label={taxAgentContract.label}
            value={values.taxAgentContract}
            error={errors.taxAgentContract && touched.taxAgentContract}
            success={values.taxAgentContract?.toString().length > 0 && !errors.taxAgentContract}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <DatepickerField
            label={taxAgentContractDate.label}
            name={taxAgentContractDate.name}
            error={errors.taxAgentContractDate && touched.taxAgentContractDate}
            success={
              values.taxAgentContractDate?.toString().length > 0 && !errors.taxAgentContractDate
            }
          />
        </Grid>
      </Grid>
    </Box>
  );
}

Fields.displayName = "Fields";

export default memo(Fields);